import React, { useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import { Link } from "react-router-dom";

import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import FileUploadTable from "./FileUploadTable";
import { GET_FILE_METADATA } from "../../../queries/archiveQrys/secureQrys/fileUploadMgmtQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import { UserContext } from "../../reuseableComponents/auth/UserContext";

const FileUploadMgmtPage = () => {
  const { user } = useContext(UserContext);
  const [getFileInfo, { loading, error, data }] = useLazyQuery(GET_FILE_METADATA);

  useEffect(() => {
    getFileInfo({ variables: { fileStatus: "Pending" }, fetchPolicy: "no-cache" });

    //The comment below MUST stay there so that react builds
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || error) {
    return (
      <div className="page-container file-upload-mgmt-container">
        <Row>
          <Col>
            {user.isSysAdmin ? (
              <>
                <span className='m-2'> | </span>
                <Link className='m-2 hyperlink' to='/secure/file-upload-admin' cypress-id='admin-file-upload'>
                  File Upload System Administration
                </Link>
              </>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
              <h3 style={{ color: "#fff" }}>File Upload Management</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="page-container file-upload-mgmt-container">
      <Row>
        <Col>
          {user.isSysAdmin ? (
            <>
              <span className='m-2'> | </span>
              <Link className='m-2 hyperlink' to='/secure/file-upload-admin' cypress-id='admin-file-upload'>
                File Upload System Administration
              </Link>
            </>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage' style={{ marginBottom: "0.5rem", paddingBottom: 0 }}>
            <h1 className="main-section-title">File Upload Management</h1>
          </HeaderBox>
        </Col>
      </Row>
      <Row style={{ marginTop: 0 }}>
        <Col style={{ paddingTop: 0 }}>
          <button
            className='float-end me-2'
            style={{
              color: "#157995",
              background: "none",
              border: "none",
              padding: 0,
              textDecoration: "underline",
              cursor: "pointer",
              minHeight: "44px"
            }}
            onClick={() => getFileInfo()}
            type='button'
          >
            Get File Upload History
          </button>
        </Col>
      </Row>
      <Row>
        <Col>{data ? <FileUploadTable data={data.getFileUploadMetadata} /> : ""}</Col>
      </Row>
    </div>
  );
};
export default FileUploadMgmtPage;
